export default __webpack_public_path__ + "static/media/file_ic.2891d1ad.svg";